import apiClient from '@/services/axios'

export const getSales = ({ signal, params }) => {
  return apiClient({
    signal,
    method: 'get',
    url: '/sales/api/v1/sales-orders',
    params,
  })
}

export const getSalesView = ({ signal, params }) => {
  return apiClient({
    signal,
    method: 'get',
    url: '/sales/api/v1/sales-orders-view',
    params,
  })
}

export const getSalesTotal = ({ signal, params }) => {
  return apiClient({
    signal,
    method: 'get',
    url: '/sales/api/v1/sales-orders-count',
    params,
  })
}

export const getSalesItems = ({ signal, business_id, order_id }) => {
  return apiClient({
    signal,
    method: 'get',
    url: `/sales/api/v1/sales-items/${order_id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const downloadManualOrder = (business_id) => {
  return apiClient({
    method: 'get',
    url: '/sales-manual/download',
    headers: {
      'Business-Id': business_id,
    },
    responseType: 'blob',
  })
}

export const getManualOrderAttachment = ({ business_id, id }) => {
  return apiClient({
    method: 'get',
    url: '/sales-manual/order-attachment',
    headers: {
      'Business-Id': business_id,
    },
    params: { id },
  })
}

export const createManualOrder = async ({ business_id, channel_id, data }) => {
  return apiClient({
    method: 'post',
    url: `/sales-manual/${channel_id}/order`,
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const verifiedBulkOrder = async ({ business_id, channel_id, file }) => {
  const form = new FormData()
  form.append('file', file)

  return apiClient({
    method: 'post',
    url: '/sales-manual/verified',
    headers: {
      'Content-Type': 'multipart/form-data',
      'Business-Id': business_id,
    },
    data: form,
  })
}

export const bulkManualOrder = async ({ business_id, channel_id, file, currency }) => {
  const form = new FormData()
  form.append('file', file)
  form.append('currency', currency)

  return apiClient({
    method: 'post',
    url: `/sales-manual/${channel_id}/upload`,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Business-Id': business_id,
    },
    data: form,
  })
}

export const addManualOrderAttachment = ({ business_id, channel_code, channel_id, order_id, order_number, files }) => {
  const formData = new FormData()
  files.forEach(file => {
    formData.append('files', file)
  })

  return apiClient({
    method: 'post',
    url: `/sales-manual/${channel_code}/order-attachment/${order_number}`,
    headers: {
      'Business-Id': business_id,
      'Channel-Id': channel_id,
      'Order-Id': order_id,
    },
    data: formData,
  })
}

export const getStoreId = ({ business_id }) => {
  return apiClient({
    method: 'get',
    url: `/logapi/vendors/business/${business_id}`,
  })
}

export const getEventHistory = ({ signal, params }) => {
  return apiClient({
    signal,
    method: 'get',
    url: '/channel/event-history/request-status',
    params,
  })
}

export const getOrderHistoryLog = ({ powerbizId, businessId, lang, signal }) => {
  return apiClient({
    signal,
    method: 'get',
    url: '/event-log/api/history/order',
    params: {
      powerbizId,
      businessId,
      lang,
    },
  })
}

export const getHistoryEventDetail = ({ eventId, lang, signal }) => {
  return apiClient({
    signal,
    method: 'get',
    url: `/event-log/api/history/event/${eventId}/detail`,
    params: { lang },
  })
}

export const getProductHistoryLog = ({ powerbizId, businessId, workspaceId, lang, signal }) => {
  return apiClient({
    signal,
    method: 'get',
    url: '/event-log/api/history/tiktok/product-channel',
    headers: {
      ...(workspaceId ? { 'Workspace-Id': workspaceId } : {}),
    },
    params: {
      powerbizId,
      businessId,
      lang,
    },
  })
}
